import React, { useState } from 'react';
import { Button, Grid, DialogActions, DialogTitle } from '@material-ui/core';
import { observer } from 'mobx-react';
import { useStores } from '../../../../../../stores/Main';
import useStyles from './SponsorsModalStyles';
import Loader from '../../../../../../components/loader/Loader';
import { EmptyVoidFunction } from '../../../../../../utils/types/Types';
import Toasters from '../../../../../../components/popUp/PopUp';
import useTranslation from '../../../../../../components/localization/customHooks/Translation';

const DeleteCountryModal = observer((props: { handleClose?: EmptyVoidFunction }) => {
  const { handleClose } = props;
  const classes = useStyles();
  const l10n = useTranslation();
  const { SponsorsStore } = useStores();

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const sendDeleteRequest = async () => {
    setIsLoading(true);
    const response = await SponsorsStore.deleteSponsor();
    if (response) {
      Toasters.success(l10n.components.sponsors.DELETE_SPONSOR_SUCCESS);
      SponsorsStore.refreshSponsors();
    }
    if (handleClose) {
      handleClose();
    }
    setIsLoading(false);
  };

  if (isLoading) {
    return (
      <Grid className={classes.loadingWindow}>
        <Loader />
      </Grid>
    );
  }
  return (
    <>
      <DialogTitle>{l10n.components.sponsors.DELETE_QUESTION}</DialogTitle>
      <DialogActions className={classes.buttonsWrapper}>
        <Button onClick={handleClose} color="primary" variant="contained" data-testid="cancelBtn">
          {l10n.shared.DELETE}
        </Button>
        <Button onClick={sendDeleteRequest} color="primary" variant="contained" autoFocus data-testid="deleteBtn">
          {l10n.shared.DELETE}
        </Button>
      </DialogActions>
    </>
  );
});

export default DeleteCountryModal;
